<p-tabView (onChange)="getRMAGroup(0)">
  <p-tabPanel header="Estimates,SalesOrders,Invoices">
    <p-accordion>
      <p-accordionTab header="Fullfillable" [selected]="true">
        <p-table [value]="fillableData" [scrollable]="true" scrollHeight="180px">
          <ng-template pTemplate="header">
            <tr>
              <th class="p-col-10">Name</th>
              <th class="p-col-2">Action</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr>
              <td class="p-col-10">{{ data.name }}</td>
              <td class="p-col-2 action">
                <app-color-box [color]="data.color"></app-color-box>
                <span class="btnBars p-mr-0" (click)="showEditFillableData(data)" pTooltip="Edit"
                  tooltipPosition="top"><i class="pi pi-pencil"></i></span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
      <p-accordionTab header="Back Order">
        <p-table [value]="allOrderBackOrderStatus" [scrollable]="true" scrollHeight="180px" dataKey="id">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 5rem"></th>
              <th class="p-col-10">Name</th>
              <th class="p-col-2">Value</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-index="rowIndex" let-expanded="expanded">
            <tr>
              <td>
                <button type="button" pButton pRipple [pRowToggler]="data"
                  class="p-button-text p-button-rounded p-button-plain"
                  [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
              </td>
              <td class="p-col-10">{{ data?.name }}</td>
              <td class="p-col-2 action">
                <p-button (click)="confirm(data)" icon="pi pi-check" label="Yes" *ngIf="data?.isDefault"></p-button>
                <p-button (click)="confirm(data)" icon="pi pi-times" label="No" *ngIf="!data?.isDefault"></p-button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="rowexpansion" let-data>
            <tr>
              <td colspan="3">
                <div class="p-field p-formgrid p-grid">
                  <div class="p-col-12 p-md-6">
                    <div class="p-field-checkbox p-mt-3">
                      <p-checkbox binary="true" inputId="kit" [ngModelOptions]="{standalone: true}"
                        (onChange)="enableBackOrderforKitBundle(data)" [disabled]="!data?.isDefault"
                        [(ngModel)]="data.EnableBackOrderForKit"></p-checkbox>
                      <label class="p-my-0" for="kit">Back Order for Kit/Package Items</label>
                    </div>
                  </div>
                  <div class="p-col-12 p-md-6">
                    <div class="p-field-checkbox p-mt-3">
                      <p-checkbox binary="true" inputId="bundle" [ngModelOptions]="{standalone: true}"
                        (onChange)="enableBackOrderforKitBundle(data)" [disabled]="!data?.isDefault"
                        [(ngModel)]="data.EnableBackOrderForBundle"></p-checkbox>
                      <label class="p-my-0" for="bundle">Back Order for Bundle Items</label>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
      <!-- <p-accordionTab header="Stage Change Commnet Popup">
                <p-table [value]="stageChange" [scrollable]="true" scrollHeight="180px">
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="p-col-10">Name</th>
                            <th class="p-col-2">Value</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-data let-index="rowIndex">
                        <tr>
                            <td class="p-col-10">{{ data?.name }}</td>
                            <td class="p-col-2 action">
                                <p-button (click)="confirm(data)" icon="pi pi-check" label="Yes"
                                    *ngIf="data?.isDefault"></p-button>
                                <p-button (click)="confirm(data)" icon="pi pi-times" label="No"
                                    *ngIf="!data?.isDefault"></p-button>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab> -->
    </p-accordion>
  </p-tabPanel>
  <p-tabPanel header="T&C">
    <app-terms-conditions></app-terms-conditions>
  </p-tabPanel>
  <p-tabPanel header="Csig">
    <app-signature></app-signature>
  </p-tabPanel>
  <p-tabPanel header="Customer Returns">
    <p-accordion [(activeIndex)]="activeIndex" (onOpen)="callEvent($event)">
      <p-accordionTab header="Return Reason" [selected]="true">
        <p-table #db [value]="allReasons" [scrollable]="true" scrollHeight="180px">
          <ng-template pTemplate="header">
            <tr>
              <th class="p-col-8">Name</th>
              <th class="p-col-2">Is Active</th>
              <th class="p-col-2">Action</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr>
              <td class="p-col-8">{{data.name}}</td>
              <td class="p-col-2">{{data.statusId==statusConstants.ACTIVE ? answertypeConstants.Yes :
                answertypeConstants.No}}</td>
              <td class="p-col-2 action">
                <ng-container *ngIf="data.createdSource!='system'">
                  <span class="btnBars p-mr-0" (click)="showEditData(data)" pTooltip="Edit"
                    tooltipPosition="top"><i class="pi
                          pi-pencil"></i></span>
                  <span class="btnBars p-mr-0" (click)="checkDelete(data,'delete')" pTooltip="Delete" tooltipPosition="top"><i
                      class="pi pi-trash"></i></span>
                </ng-container>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6">{{noDataFieldData}}</td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
      <p-accordionTab header="Return Request Type">
        <p-table #db [value]="allTypes" [scrollable]="true" scrollHeight="180px">
          <ng-template pTemplate="header">
            <tr>
              <th class="p-col-8">Name</th>
              <th class="p-col-2">Is Active</th>
              <th class="p-col-2">Is Default</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr>
              <td class="p-col-8">{{data.name}}</td>
              <td class="p-col-2">{{data.statusId==statusConstants.ACTIVE ? answertypeConstants.Yes :
                answertypeConstants.No}}</td>
              <td class="p-col-2 action">
                <p-radioButton [value]="true" [(ngModel)]="data.isDefault"
                  (onClick)="eventCalled(data)"></p-radioButton>
                <span *ngIf="data?.isDefault" class="p-ml-2"> Yes</span>
                <span *ngIf="!data?.isDefault" class="p-ml-2"> No</span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6">{{noDataFieldData}}</td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
      <p-accordionTab header="Return Location" [selected]="true">
        <div class="p-grid">
          <div class="p-col-12">
            <label>RMA Location: </label>
            <p-dropdown [options]="rmaLocations" optionLabel="name" [(ngModel)]="defaultLocation"
              (onChange)="setDefaultRMALocation()" placeholder="Select location"></p-dropdown>
          </div>
        </div>
      </p-accordionTab>
      <p-accordionTab header="Search By">
        <p-table #db [value]="searchBy" [scrollable]="true" scrollHeight="180px">
          <ng-template pTemplate="header">
            <tr>
              <th class="p-col-8">Name</th>
              <th class="p-col-2">Is Active</th>
              <th class="p-col-2">Is Default</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-index="rowIndex">
            <tr>
              <td class="p-col-8">{{data.name}}</td>
              <td class="p-col-2">{{data.statusId==statusConstants.ACTIVE ? answertypeConstants.Yes :
                answertypeConstants.No}}</td>
              <td class="p-col-2 action">
                <p-radioButton [disabled]="true" [value]="true" [(ngModel)]="data.isDefault"></p-radioButton>
                <span *ngIf="data?.isDefault" class="p-ml-2"> Yes</span>
                <span *ngIf="!data?.isDefault" class="p-ml-2"> No</span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6">{{noDataFieldData}}</td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
    </p-accordion>
  </p-tabPanel>
</p-tabView>

<p-dialog header="{{fullfillHeader}}" [(visible)]="displayEditFullfillable" [modal]="true" [responsive]="true"
  [style]="{ width: '60vw' }">
  <div class="header">
    <h5>Fullfillable Information</h5>
  </div>
  <div class="card">

    <div class="p-field p-formgrid p-grid">
      <div class="p-col-12 p-md-6">
        <label>Fullfillable Name
          <span style="color: red">*</span></label>
        <input type="text" pInputText [(ngModel)]="name" />
      </div>
      <div class="p-col-12 p-md-6">
        <label>Fullfillable Color
          <span style="color: red">*</span></label>
        <p-colorPicker appendTo="body" [(ngModel)]="color"></p-colorPicker>
      </div>
    </div>
  </div>
  <p-footer>
    <button type="button" pButton (click)="displayEditFullfillable = false" label="Cancel"
      class="p-button-secondary"></button>
    <button type="button" pButton label="Save" (click)="save()"></button>
  </p-footer>
</p-dialog>

<p-dialog header="{{addEditHeader}}" [modal]="true" *ngIf="displayAddEditData" [(visible)]="displayAddEditData"
  [style]="{width: '50vw'}" [baseZIndex]="10000" (onHide)="reasonForm.reset();">
  <form [formGroup]="reasonForm">
    <div class="p-grid">
      <div class="p-col-12" *ngIf="!isEditFieldData">
        <label for="type">Fields Type <span style="color: red;">*</span></label>
        <p-dropdown [options]="dataTypes" formControlName="groupId" optionLabel="name"
          placeholder="Select Field Type"></p-dropdown>
      </div>
      <div class="p-col-12" *ngIf="isEditFieldData">
        <div class="header">
          <h5 class="p-mb-0">Fields Name -- {{dataTypes[0]?.name}}
            <p-inputSwitch class="header-switch" formControlName="statusId" (onChange)="checkDelete(reasonForm.value,'status')">
            </p-inputSwitch>
          </h5>
        </div>
      </div> 
      <div class="p-col-12">
        <label for="name">Name <span style="color: red;">*</span></label>
        <input type="text" pInputText formControlName="name">
        <small *ngIf="invalidData == true" class="p-invalid">
          Name exists in the list already
        </small>
      </div>
      <div class="p-col-12">
        <label for="name">Description</label>
        <input type="text" pInputText style="width: 100%;" formControlName="description">
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button pButton (click)="closeAddEditData()" label="Cancel" class="p-button-secondary"></button>
    <button pButton label="Save" [diabled]="!reasonForm.valid" (click)="saveReason(reasonForm.value)"></button>
  </ng-template>
</p-dialog>